import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import { Helmet } from 'react-helmet';
import { GlobalContent } from '../../services';

export const RcmGlobalContent = ({ globalContent }: { globalContent: GlobalContent }): JSX.Element => {
  const data = useStaticQuery(graphql`
    query SbImages {
      fundImages {
        internal {
          content
        }
      }
    }
  `);

  const newProps = {
    ...globalContent,
    fundImages: JSON.parse(data.fundImages.internal.content),
  };

  return (
    <Helmet>
      <meta name="global-content" content={JSON.stringify(newProps)} />
    </Helmet>
  );
};
